export default "__VITE_ASSET__CVpNrLUH__"